var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"viewZone"},[_c('div',{staticClass:"introBox"},_vm._l((_vm.posterList),function(poster,index){return _c('img',{key:index,attrs:{"src":poster.src + '?imageView2/0/format/webp',"alt":""}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }